import { AuthService } from './../containers/auth/auth.service'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../environments/environment'
import { Observable } from 'rxjs'
import { Store } from '@ngrx/store'

@Injectable()
export class SharedService {
  constructor(
    private http: HttpClient,
    private store: Store<any>,
    private authService: AuthService,
  ) {}

  public initialize() {
    return new Promise<void>((resolve) => {
      this.authService.loadPermissions()
      resolve()
    })
  }

  public fetchImageTypes(model: string): Observable<any> {
    const url = `${environment.API_ENDPOINT}/list/imageTypes/${model}`
    return this.http.get(url, {})
  }

  public fetchLocalization(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/localization`
    return this.http.get(url, {})
  }

  public searchStreets(keyword: string): Observable<any> {
    const url = `${environment.API_ENDPOINT}/list/street`
    return this.http.post(url, {
      filters: keyword
        ? {
            or: [{ field: 'name', value: keyword }],
          }
        : {},
      pageSize: 100,
    })
  }

  public searchGisStreets(keyword: string): Observable<any> {
    const url = `${environment.API_ENDPOINT}/gis/searchStreet?s=${keyword}`
    return this.http.get(url, {})
  }

  public searchCommunities(keyword: string): Observable<any> {
    const url = `${environment.API_ENDPOINT}/list/community`
    return this.http.post(url, {
      filters: keyword
        ? {
            or: [{ field: 'name', value: keyword }],
          }
        : {},
      pageSize: 100,
    })
  }

  public searchContactTypes(keyword: string): Observable<any> {
    const url = `${environment.API_ENDPOINT}/list/contactType`
    return this.http.post(url, {
      filters: keyword
        ? {
            or: [{ field: 'name', value: keyword }],
          }
        : {},
      pageSize: 100,
    })
  }

  public searchContactTitles(keyword: string): Observable<any> {
    const url = `${environment.API_ENDPOINT}/list/contactTitle`
    return this.http.post(url, {
      filters: keyword
        ? {
            or: [{ field: 'name', value: keyword }],
          }
        : {},
      pageSize: 100,
    })
  }

  public searchPaymentPurposes(keyword: string): Observable<any> {
    const url = `${environment.API_ENDPOINT}/list/paymentPurpose`
    return this.http.post(url, {
      filters: keyword
        ? {
            or: [{ field: 'name', value: keyword }],
          }
        : {},
      pageSize: 100,
    })
  }

  public searchOrganizations(keyword: string): Observable<any> {
    const url = `${environment.API_ENDPOINT}/list/organization`
    return this.http.post(url, {
      filters: keyword
        ? {
            or: [{ field: 'name', value: keyword }],
          }
        : {},
      pageSize: 100,
    })
  }

  public searchIndustries(keyword: string): Observable<any> {
    const url = `${environment.API_ENDPOINT}/list/industry`
    return this.http.post(url, {
      filters: keyword
        ? {
            or: [{ field: 'name', value: keyword }],
          }
        : {},
      pageSize: 100,
    })
  }

  public searchFinancialInstitutions(keyword: string): Observable<any> {
    const url = `${environment.API_ENDPOINT}/list/financialInstitution`
    return this.http.post(url, {
      filters: keyword
        ? {
            or: [{ field: 'name', value: keyword }],
          }
        : {},
      pageSize: 100,
    })
  }

  public fetchSwitchableDataCycles(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/datacycle/switchables`
    return this.http.get(url, {})
  }

  public fetchRoundFactors(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/settings/roundFactor/list`
    return this.http.get(url, {})
  }

  public fetchAreaRounding(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/settings/roundFactorArea/list`
    return this.http.get(url, {})
  }

  public searchWards(keyword: string): Observable<any> {
    const url = `${environment.API_ENDPOINT}/list/ward`
    return this.http.post(url, {
      filters: keyword
        ? {
            or: [{ field: 'name', value: keyword }],
          }
        : {},
      pageSize: 100,
    })
  }

  public detectWardByCoordinate(coordinate: any[]): Observable<any> {
    const url = `${environment.API_ENDPOINT}/gis/getWard/${coordinate[0]}/${coordinate[1]}`
    return this.http.get(url, {})
  }

  public fetchSearchTypes(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/search/searchTypes`
    return this.http.get(url, {})
  }

  public fetchWards(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/gis/getWards`
    return this.http.get(url, {})
  }

  public fetchDiscountGroups(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/list/discountGroup`
    return this.http.post(url, {})
  }

  public fetchAssessableTypes(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/list/assessibility`
    return this.http.get(url, {})
  }

  public fetchPropertyStatuses(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/list/status`
    return this.http.get(url, {})
  }

  public fetchOrganizations(payload: any): Observable<any> {
    const url = `${environment.API_ENDPOINT}/list/organization`
    return this.http.post(url, payload)
  }

  public fetchBusinessCategories(payload: any): Observable<any> {
    const url = `${environment.API_ENDPOINT}/list/businessCategory`
    return this.http.post(url, payload)
  }

  public fetchContacts(payload: any): Observable<any> {
    const url = `${environment.API_ENDPOINT}/list/contact`
    return this.http.post(url, payload)
  }

  public fetchContactTitles(payload: any): Observable<any> {
    const url = `${environment.API_ENDPOINT}/list/contactTitle`
    return this.http.post(url, payload)
  }

  public fetchBusinessSubcategoryTypes(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/businessCategory/subcategory/type/list`
    return this.http.post(url, {})
  }

  public fetchBusinessSubcategoryCalculationTypes(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/businessCategory/subcategory/calculationType/list`
    return this.http.post(url, {})
  }

  public exportListData({ filters, module }): Observable<any> {
    let url = `${environment.API_ENDPOINT}/${module}/list/export`

    return this.http.post(
      url,
      {
        filters,
      },
      {
        observe: 'response',
        responseType: 'blob' as 'json',
      },
    )
  }

  fetchActiveLayers(payload?: any): Observable<any> {
    const url = `${environment.API_ENDPOINT}/list/layer`

    if (payload) {
      return this.http.post(url, payload || {})
    }

    return this.http.get(url, {})
  }

  detectLayer({ id, ...data }: any): Observable<any> {
    const url = `${environment.API_ENDPOINT}/gis/layer/${id}/detect`
    return this.http.post(url, data)
  }
  detectAllLayers(data: any): Observable<any> {
    const url = `${environment.API_ENDPOINT}/gis/layer/detect`
    return this.http.post(url, data)
  }

  fetchForms(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/list/evaluationForm`
    return this.http.post(url, {})
  }

  fetchStaticTemplate(key: string, lang: string): Observable<any> {
    const url = `${environment.API_ENDPOINT}/public/staticContent/${key}/${lang}`
    return this.http.get(url, {})
  }

  acceptTermsOfService(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/auth/agreeTerms`
    return this.http.get(url, {})
  }

  fetchMobileTaskTypes(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/list/mobileTaskType`
    return this.http.post(url, {})
  }

  fetchLayerFeatures(payload?: any): Observable<any> {
    const url = `${environment.API_ENDPOINT}/list/layerFeature`

    return this.http.post(url, payload)
  }

  fetchTemplateTypes(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/list/printTemplateTypes`
    return this.http.post(url, {})
  }

  fetchAuditLogTypes(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/list/auditLogTypes`
    return this.http.post(url, {})
  }

  fetchPropertyTypesByCode(code: string): Observable<any> {
    const url = `${environment.API_ENDPOINT}/property/getPropertyTypesByCode/${code}`
    return this.http.get(url, {})
  }

  fetchLicenseTypes(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/list/licenseType`
    return this.http.post(url, {})
  }

  fetchPropertyTypes(id: any): Observable<any> {
    const url = `${environment.API_ENDPOINT}/property/${id}/types`
    return this.http.get(url, {})
  }

  fetchMobileUserModes(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/mobileUser/modes`
    return this.http.get(url, {})
  }

  fetchPostprocessorSlotTypes(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/postprocessor/slotType/list`
    return this.http.post(url, {})
  }

  fetchDocumentTypes(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/list/documentType`
    return this.http.post(url, {})
  }
}
